import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { InctvLedgerLineSaleLineList } from '@/sc/entities/dirSaleLine/InctvLedgerLineSaleLineList';
import { augInctvFieldDefs } from '@/sc/inctvFieldDefs';
import { useEffect, useLayoutEffect } from 'react';

export const InctvRbtLineDetail = () => {
  const { entityObj, setEntityObj, entityDef } = useEntityMgr();
  const rsrc = useRsrc();

  // Stamp a clean placeholder before paint so the raw Entity code never flashes on screen
  useLayoutEffect(() => {
    if (entityObj.id && !entityObj.name) {
      setEntityObj({ ...entityObj, name: entityDef.displayName });
    }
  }, [entityObj, setEntityObj, entityDef]);

  // The line has no code of its own, so derive a readable title from its Product and Customer
  useEffect(() => {
    if (!entityObj.prodId || !entityObj.custId) return;

    Promise.all([rsrc.byId('md', 'PROD', entityObj.prodId), rsrc.byId('md', 'CUST', entityObj.custId)]).then(
      ([prodObj, custObj]) => {
        if (!prodObj?.code || !custObj?.code) return;

        const computedName = prodObj.code + ' ' + custObj.code + ' Rebate Line';
        if (entityObj.name !== computedName) {
          setEntityObj({ ...entityObj, name: computedName });
        }
      },
    );
  }, [entityObj, setEntityObj, rsrc]);

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm augFieldDefs={augInctvFieldDefs} /> },
    {
      id: 'dirSaleLine',
      label: 'Direct Sale Lines',
      content: <InctvLedgerLineSaleLineList inctvLedgerLineId={entityObj.inctvLedgerLineId} />,
    },
  ];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
